import React, { useEffect, useState } from 'react';
import Header from './components/1-header/header';
import Hero from './components/2-hero/hero';
import Main from './components/3-main/main';
import Contact from './components/4-contact/contact';
import Footer from './components/5-footer/footer';

const App = () => {
  const [showScrollBTN, setshowScrollBTN] = useState(false); // ✅ صححنا هنا

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setshowScrollBTN(true);
      } else {
        setshowScrollBTN(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div id="up" className='container'>
      <Header />
      <Hero />
      <div className='divider'></div>
      <Main />
      <div className='divider'></div>
      <Contact />
      <div className='divider'></div>
      <Footer />
      {showScrollBTN && (
        <a href="#up">
          <button className="fa fa-arrow-up scroll2Top"></button>
        </a>
      )}
    </div>
  );
};

export default App;
